import React from 'react'

export default class Message extends React.Component {
  render() {
    return (
      <div className="white">
        <div className="wrap unpadded">
          <h3 className="centered">{this.props.children}</h3>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/message.js